import WordPressContent from "components/WordPressContent/WordPressContent";

const PrivacyPolicy = () => {
  return (
    <div id="main-content-target" className="privacy-page">
      <WordPressContent slug="privacy-policy-mobile" title="Privacy Policy" />
    </div>
  );
}

export default PrivacyPolicy;
